export const parseJwtPayload = (token) => {
  if (!token) return null;

  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

export const isTokenExpired = (token) => {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) return true;
  return Date.now() >= payload.exp * 1000;
};

export const getStoredToken = () => {
  const profile = localStorage.getItem('profile');
  if (!profile) return null;

  try {
    const parsedProfile = JSON.parse(profile);
    return parsedProfile?.token || null;
  } catch {
    return null;
  }
};

export const clearAuthStorage = () => {
  localStorage.removeItem('profile');
  localStorage.removeItem('token');
  localStorage.removeItem('lastActive');
  localStorage.removeItem('userType');
  localStorage.removeItem('workerPermissions');
  sessionStorage.clear();
};

export const isAuthSessionValid = () => {
  const token = getStoredToken();
  if (!token) return false;

  if (isTokenExpired(token)) {
    clearAuthStorage();
    return false;
  }

  return true;
};

export const shouldForceLogoutOn401 = (error) => {
  if (error?.response?.status !== 401) return false;

  const token = getStoredToken();
  if (!token || isTokenExpired(token)) return true;

  const message = String(error.response?.data?.message || '').toLowerCase();
  return (
    message.includes('expired') ||
    message.includes('invalid or expired') ||
    message.includes('authentication required')
  );
};
